import * as angular from 'angular';
import * as _ from 'lodash';

import { ComponentDefinition, IErrorReporting, IValueViewModel, ObjectType } from '../../../models';
import { PivotTableRowSeriesDefinition } from '../PivotTableRowSeriesDefinition';
import { ISeriesSelectorService } from '../../../services/data';

class PivotTableRowsDefinitionController implements angular.IComponentController {
    errorFields: IErrorReporting[];
    isBindable: boolean;
    rowSeries: PivotTableRowSeriesDefinition;
    rowSeriesFormController: angular.IFormController;
    viewModels: IValueViewModel[];
    viewModel: IValueViewModel;

    static $inject = ['seriesSelectorService'];
    constructor(private _seriesSelectorService: ISeriesSelectorService) {
    }

    $onInit() {

        this.errorFields = [
            {
                propertyName: 'rowSeriesBin',
                errorName: 'rowSeriesBin',
                messages: [
                    {
                        key: 'required',
                        value: 'Number of bins is required'
                    },
                    {
                        key: 'min',
                        value: 'Number of bins must be an integer greater than 0'
                    },
                    {
                        key: 'float',
                        value: 'Number of bins must be an integer greater than 0'
                    },
                    {
                        key: 'pattern',
                        value: 'Number of bins must be an integer greater than 0'
                    }
                ]
            },
            {
                propertyName: 'rowSeriesMin',
                errorName: 'rowSeriesMin',
                messages: [
                    {
                        key: 'required',
                        value: 'Min is required'
                    },
                    {
                        key: 'float',
                        value: 'Min must be a number'
                    },
                    {
                        key: 'max',
                        value: 'Min must be smaller than max'
                    }
                ]
            },
            {
                propertyName: 'rowSeriesMax',
                errorName: 'rowSeriesMax',
                messages: [
                    {
                        key: 'required',
                        value: 'Max is required'
                    },
                    {
                        key: 'float',
                        value: 'Max must be a number'
                    },
                    {
                        key: 'min',
                        value: 'Max must be greater than min'
                    }
                ]
            },
            {
                propertyName: 'rowSeriesDecimals',
                errorName: 'rowSeriesDecimals',
                messages: [
                    {
                        key: 'required',
                        value: 'Decimals must be an integer greater than or equal to 0.'
                    },
                    {
                        key: 'float',
                        value: 'Decimals must be an integer greater than or equal to 0.'
                    },
                    {
                        key: 'min',
                        value: 'Decimals must be an integer greater than or equal to 0.'
                    },
                    {
                        key: 'pattern',
                        value: 'Decimals must be an integer greater than or equal to 0.'
                    }
                ]
            }
        ];
    }

    $onChanges(changesObj: angular.IOnChangesObject) {
        if (this.rowSeries && this.viewModels) {
            this.viewModel = _.find(this.viewModels, vm => vm.guid === this.rowSeries.guid);
        }
    }

    drop(data: { itemId: string }) {
        if (this.rowSeries) {
            let { value, isBoundToGroup } = this.rowSeries;
            const guid = data.itemId;
            const vm = _.find(this.viewModels, vm => vm.guid === guid);
            if (this._seriesSelectorService.getValues(vm).map(d => d.key.indexOf(value) < 0)) {
                value = this._seriesSelectorService.getAvailableValueType(vm, []);
            }
            if (vm.objectType === ObjectType.Tag) {
                isBoundToGroup = false;
            }
            this.viewModel = vm;
            this.rowSeries = {
                guid,
                isBoundToGroup,
                value,
                bin: this.rowSeries.bin,
                originalGuid: '',
                decimals: this.rowSeries.decimals,
                min: vm.min,
                max: vm.max
            };
        }
    }

    onMinMaxChange(min: number, max: number) {
        if (min !== null && max !== null && min !== undefined && max !== undefined) {
            this.rowSeriesFormController['rowSeriesMax'].$setValidity('min', min < max);
            this.rowSeriesFormController['rowSeriesMin'].$setValidity('max', min < max);
        }
    }
}

export const wtPivotTableRowsDefinition: ComponentDefinition = {
    componentId: 'wtPivotTableRowsDefinition',
    controller: PivotTableRowsDefinitionController,
    template: require('./pivotTableRowsDefinition.component.html'),
    controllerAs: 'vm',
    bindings: {
        isBindable: '<?',
        rowSeries: '=', // object gets replaced inside of the control
        viewModels: '<'
    }
};
